// extracted by mini-css-extract-plugin
export default {"media":"media__Dbj5a"};